import { Injectable }           from '@angular/core';
import { Observable }           from 'rxjs/Observable';
import { BehaviorSubject }      from 'rxjs/BehaviorSubject';
import                               'rxjs/add/operator/map';
import                               'rxjs/add/operator/filter';
import                               'rxjs/add/Observable/timer';
import                               'rxjs/add/operator/do';
import                               'rxjs/add/operator/switch';

export enum AuthState {
    LOGGED_IN,
    LOGGED_OUT
}

const SESSION_TIMEOUT = 10000;

@Injectable()
export class SessionService {
    private authState: AuthState;
    private authManager: BehaviorSubject<AuthState>;
    public authChange$: Observable<AuthState>;

    constructor() {
        this.authManager = new BehaviorSubject(AuthState.LOGGED_OUT);
        this.authChange$ = this.authManager.asObservable();
        this.authChange$
            .filter((authState: AuthState) => authState === AuthState.LOGGED_IN)
            .map((authState: AuthState) => Observable.timer(SESSION_TIMEOUT))
            .do(() => {
                console.log('Logged In. Session Timout counting down from now');
                }

                )


            .switch()
            .subscribe(() => {
                console.log('Timer ended: Logging out');
                this.logout();
            });
    }

    login() {
        this.setAuthState(AuthState.LOGGED_IN);
    }

    logout() {
        this.setAuthState(AuthState.LOGGED_OUT);
    }

    emitAuthState(): void {
        this.authManager.next(this.authState);
    }

    private setAuthState(newAuthState: AuthState): void {
        console.log('SessionService: setAuthState: ',
            AuthState[newAuthState.toString()]);
        if (newAuthState != this.authState) {
            this.authState = newAuthState;
            this.emitAuthState();
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/+auth/+login/session.service.ts